define('modules/editor/views/controls/resizebar',['require','exports','module','base/itemview','../../models/editorstate'],function(require, exports, module){
  "use strict";
  var BaseView = require("base/itemview"),
      EditorState = require("../../models/editorstate");
  /**
   * ResizeBar base view
   */
  var ResizeBar = BaseView.extend({
    events: {
      "mousedown .handle": "_onHandleMouseDown"
    },
    initialize: function(options){
      this.originalGeo = null;
      this.resizeState = options.resizeState;
      /** Throttled version of the _resizeElement function */
      this._throttledResize = _.throttle(this._resizeElement, 200);
    },
    _onHandleMouseDown: function(e){
      //left button only
      if(e.which !== 1) { return; }
      var $handle = this.$(e.target);
      e.stopPropagation();
      e.stopImmediatePropagation();
      this.handleId = $handle.attr("id");
      $("body").addClass("noselect resize").css("cursor", $handle.css("cursor"));
      //keep this handle cursor on all the page
      //console.log('Start resize on', this.resizeState.get("model").name);
      var element = this.resizeState.get("model");
      element.trigger("notify:stop");
      element.trigger("resize:start");
      //console.log("Handle pressed on ", this.handleId.replace("lpg-", ""), e.pageX, e.pageY);
      $(document).on("mousemove", _.throttle(_.bind(this._onHandleMove, this), 10));
      $(document).on("mouseup", _.bind(this._onHandleRelease, this));
    },
    _onHandleRelease: function(e){
      $("body").removeClass("noselect resize").css("cursor", "default");
      $(document).off("mousemove");
      $(document).off("mouseup");
      var element = this.resizeState.get("model");
      element.trigger("notify:start");
      element.trigger("resize:stop");
      EditorState.deselect();
      EditorState.selectElement(this.resizeState.get("view"));
    },
    _onHandleMove: function(e){
      /**
       * Event data for child views _processResize method
       * @type {Object} Contains direction like n, ne, e, se, s, sw, w, nw
       */
      var handle = this.$("#" + this.handleId),
          handleOffset = handle.offset();
      //handleOffset.top += parseInt(handle.height()) / 2;
      //handleOffset.left += parseInt(handle.width()) / 2;
      //var position = this._adjustPageCoords(e);
      var eventData = {
        //send only compass direction (n, ne, ...)
        direction: this.handleId.replace("lpg-", ""),
        deltaX: Math.floor(e.pageX - handleOffset.left),
        deltaY: Math.floor(e.pageY - handleOffset.top),
        origTop: this.resizeState.get("originalPos").y,
        origLeft: this.resizeState.get("originalPos").x,
        origHeight: this.resizeState.get("originalSize").height,
        origWidth: this.resizeState.get("originalSize").width
      };

      /** @see _processResize below */
      var resizeData = this._processResize(eventData);
      this._resizeElement(resizeData);
    },
    _adjustPageCoords: function(e) {
      var view = this.resizeState.get("view"),
          sectionOffset = view.parent.$el.offset(),
          sectionSize = view.parent.model.getSize(),
          rightBound = sectionOffset.left + sectionSize.width,
          bottomBound = sectionOffset.top + sectionSize.height;
      return {
        pageX: e.pageX < rightBound? e.pageX : rightBound,
        pageY: e.pageY < bottomBound? e.pageY : bottomBound
      };
    },
    /**
     * Overriden in child views, transforms
     * mouse deltaX and deltaY into geometry deltas
     * @param  {Object} resizeData handleMove event data
     * @return {Object}            geometryDeltas
     */
    _processResize: function(resizeData){
      // Override in child views to transform deltaX and deltaY
      // into top, left, width, height deltas
      throw new Error("Should be overriden!");
      // return _.extend(resizeData, {
      //   newTop: 0,
      //   newLeft: 0,
      //   newHeight: 0,
      //   newWidth: 0
      // });
    },
    /**
     * Applies the geometry transformation to the model
     * @param  {Object} geoData resizeData + new[Top|Left|Height|Width]
     */
    _resizeElement: function(geoData){
      var elementModel = this.resizeState.get("model");
      if(!elementModel) { return; }
      var size = {
            width: geoData.newWidth || geoData.origWidth,
            height: geoData.newHeight || geoData.origHeight
          },
          position = {
            x: geoData.newLeft || geoData.origLeft,
            y: geoData.newTop || geoData.origTop
          };
      if (elementModel._adjustResize) {
        var data = elementModel._adjustResize(geoData);
        size = _.pick(data, "width", "height");
        position = _.pick(data, "x", "y");
      }
      if(geoData.newHeight || geoData.newWidth){
        elementModel.setSize(size);
      }
      if(geoData.newTop || geoData.newLeft){
        elementModel.setPosition(position);
      }
    },
    _adjustToRightBound: function(width) {
      var view = this.resizeState.get("view"),
          section = view.parent,
          viewOffset = view.$el.offset(),
          sectionOffset = section.$el.offset(),
          sectionWidth = (section.model && section.model.getSize().width) || section.$el.width(),
          newWidthPosition = viewOffset.left + width,
          sectionRightBound = sectionOffset.left + sectionWidth;
      return newWidthPosition < sectionRightBound? width : (sectionRightBound - viewOffset.left);
    },
    _adjustToBottomBound: function(height) {
      var view = this.resizeState.get("view");
      if (view.model.name === "section") return height;
      var section = view.parent,
          viewOffset = view.$el.offset(),
          sectionOffset = section.$el.offset(),
          sectionSize = section.model.getSize(),
          newHeightPosition = viewOffset.top + height,
          sectionBottomBound = sectionOffset.top + sectionSize.height;
      return newHeightPosition < sectionBottomBound? height : (sectionBottomBound - viewOffset.top);
    },
    /**
     * Given an element's View, this
     * @param  {[type]} elementView [description]
     * @return {[type]}             [description]
     */
    getElementPageGeometry:function(elementView){
      if(!elementView || !elementView.model) { return; }
      var data = {},
          $el = elementView.$el,
          model = elementView.model,
          modelPos = model.getPosition(),
          modelSize = model.getSize();

      var absCoords = elementView.$el.offset();
      var pageCoords = elementView.$el.parents(".lpg-page").offset();
      if(!pageCoords) {
        pageCoords = { top: 0, left: 0 };
      }

      data.top = absCoords.top - pageCoords.top;
      data.left = absCoords.left - pageCoords.left;
      data.height = Math.max(modelSize.height || 0, elementView.$el.outerHeight());
      data.width = Math.max(modelSize.width || 0, elementView.$el.outerWidth());

      return data;
    }
  });

  module.exports = ResizeBar;
});

